import { useEffect } from "react"
import { useMsal } from "@azure/msal-react"

const AuthRedirect = () => {
  const { instance } = useMsal()
  useEffect(() => {
    instance.loginRedirect()
  }, [instance])
}

export default AuthRedirect
